// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"71":"f78a787f","237":"29951a04","264":"ff00818e","440":"9d6052f3","495":"3440a1a6","568":"4a594353","638":"8d366f76"}[chunkId] + ".chunk.js";
};